const accountRules = require('./account').default;
export { accountRules, };
